import { useSelector } from "react-redux";
import "./App.css";
import { RenderRout } from "./router";
import { useEffect, useMemo } from "react";
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import createAppTheme, { darkenColor, INK, NAV } from "./theme/createAppTheme";
import { installSelectTypeahead } from "./utils/selectTypeahead";

function App() {
  const users = useSelector((state) => state.UserProfile.profile);
  const user = JSON.parse(localStorage.getItem("userData"));

  const theme = useMemo(() => createAppTheme(), []);

  function changeFavicon() {
    let favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) {
      favicon = document.createElement("link");
      favicon.rel = "icon";
      document.head.appendChild(favicon);
    }
    favicon.href = users?.logo || user?.logo ||"/image/logo.svg";
    document.title =
      users?.companyName || user?.companyName
        ? `${users?.companyName || user?.companyName} ${
            ""
          }`.trim()
        : document.title;
  }

  useEffect(() => {
    changeFavicon();
    // eslint-disable-next-line
  }, [user]);
  

  useEffect(() => installSelectTypeahead(), []);


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <style>
        {`
          .intersight_menu, .gradient_bg ,  .bs-wizard > .bs-wizard-step > .bs-wizard-dot, .filter_option a.active {
            background-color: ${INK};
          }
          .blue-btn, .btn-primary {
            background-color: ${INK};
            border-color: ${INK};
            color: #fff;
          }
          
             .engage-tabs .nav .nav-item .nav-link.active {
    border-bottom: 3px solid ${INK};
    color: ${INK};
}
    
   
     .border-btn, .imagesMultiple {
    border: 1px solid ${INK};
    color: ${INK};
    
}


 .sidebar-accordian .accordion-body , .sidebar-accordian .accordion-button ,.sidebar-accordian .accordion-button:not(.collapsed) ,.sidebar-accordian .accordion-header {
     background-color: ${NAV};
    
}


    .engage-tabs .nav .nav-item .nav-link.active svg path {
    fill: ${INK};
}
      
.menu_scrollbar::-webkit-scrollbar-thumb, .brand button , .person_icon {
  background: ${NAV};
}
  .menu_div li a.active{
  background: ${darkenColor(NAV, -12)};
  color: #fff;
  }
  .menu_div li a:hover {
  background: ${darkenColor(NAV, -12)};
  }

  .menu_div li a.active svg path, .menu_div li a:hover svg path {
    fill: #fff;
}
    .blue-btn:hover, .btn-primary:hover, .border-btn:hover {
    background-color: ${darkenColor(INK, 18)};
    border-color: ${darkenColor(INK, 18)};
    color: #fff;
}
    .form-check-input:checked {
        background-color: ${INK};
    border-color: ${INK};
    }
    .bs-wizard > .bs-wizard-step > .progress > .progress-bar {
     background:${INK}
    }
     .dasboard_title{
     color: ${INK};
     }
     .product_question{
     background:${INK}
     }
     .color-blue, .stongtag{
     color: ${INK};
     }
.engage-tabs .window-measurement-tabs .nav .nav-item .nav-link.active {
    border-bottom: 3px solid ${INK};
    background-color: ${INK};
   
}
    .blue-outline-btn {
    border: 1px solid ${INK};
    color: ${INK};
}
    .blue-outline-btn:hover {
    background-color: ${INK};
    color: #fff;
}
    .estimate-header  {
    background-color: ${NAV};
   
}
     .loaderproduct  {
     border-top: 2px solid ${INK};
   
}
    .option-scroll {
  scrollbar-color: ${INK} #f0f0f0;
}
  .intersight_home, .notification_alert{
   background-color: ${NAV};
      }
   .loading-screens{
     background: ${NAV};
   }
  
        `}
      </style>
      <RenderRout />
    </ThemeProvider>
  );
}

export default App;
